import * as Sentry from "@sentry/react";
import type { ComponentType, ReactElement } from "react";

const DefaultFallback = () => <p>An error has occurred</p>;

export const { ErrorBoundary } = Sentry;

export const withErrorBoundary = <P extends Record<string, unknown>>(
  Component: ComponentType<P>,
  fallback: ReactElement = <DefaultFallback />
) => {
  const Boundary = (props: P) => (
    <ErrorBoundary fallback={fallback}>
      <Component {...props} />
    </ErrorBoundary>
  );

  const displayName = Component.displayName || Component.name || "Component";

  Boundary.displayName = `${displayName}WithErrorBoundary`;

  return Boundary;
};
